<template>
  <div class="study">
    <publicHeader @child-event="myInfoEvent"></publicHeader>
    <studyHeader
      :subjectIndex="subjectIndex"
      :studyNav="studyNav"
      :myInfo="myInfo"
      :public="public"
    ></studyHeader>
    <div class="video_cont bg_gray">
      <div class="w1200">
        <div class="flex famous_position">
          <div class="my_position_l cl_gray">
            <img src="../../../static/icon_position.png" class="mar5" />
            <p>
              当前位置：<router-link to="/" class="cl_gray">首页</router-link> >
              <router-link to="/study" class="cl_gray">趣学习</router-link> >
              {{ data.name }}
            </p>
          </div>
          <div class="my_position_r cl_violet" @click="$router.go(-1)">
            <span class="mar5">返回上级</span
            ><img src="../../../static/return_violet.png" />
          </div>
        </div>
        <div class="video" >
          <div class="video_header f20px cl_dark">{{ data.name }}</div>
          <div class="video_div flex">
            <div
              class="video_l"
              v-if="data.type == 2 && data.is_buy == 2"
            ></div>
            <div class="video_l" v-else>
              <video-player
                v-if="JSON.stringify(data) != '{}'"
                class="video-player vjs-custom-skin block"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"
                @play="onPlayerPlay($event)"
                @timeupdate="onPlayerTimeupdate($event)"
                @pause="onPlayerPause($event)"
                @ended="onPlayerEnded($event)"
              ></video-player>
              <div class="video_l_btm f16px cl_white">
                <img src="../../../static/icon_video.png" class="mar5" />
                <span>{{ data.browse_num }}</span>
              </div>
            </div>
            <div class="video_r">
              <div class="video_r_title flex">
                <div class="video_r_title_l tc cl_white f16px">
                  <img src="../../../static/icon_catalog.png" />
                  <p class="mat10">目录</p>
                </div>
                <div class="video_teacher" v-if="JSON.stringify(data) != '{}'">
                  <router-link
                    :to="{ path: '/teacher', query: { id: data.teacher_id } }"
                    class="video_teacher_l radius mar5"
                    ><img :src="data.teacher_data.avatar" class="block radius"
                  /></router-link>
                  <div class="video_teacher_r bg_gray">
                    <router-link
                      :to="{ path: '/teacher', query: { id: data.teacher_id } }"
                      class="f16px"
                      >{{ data.teacher_data.name }}</router-link
                    >
                    <p
                      class="f12px cl_gray mat5"
                      v-html="data.teacher_data.intro"
                    ></p>
                  </div>
                </div>
              </div>
              <div class="video_r_cont bg_white">
                <div
                  class="video_r_list"
                  v-for="(item, index) in data.video"
                  :key="index"
                  :class="{ on: item.id == list_cur.id }"
                >
                  <div
                    class="video_r_list_top f18px cl_dark"
                    @click="videoCheck(index)"
                  >
                    <img
                      src="../../../static/icon_video_violet.png"
                      v-if="item.id == list_cur.id"
                    />
                    <img src="../../../static/icon_video.png" v-else />
                    <span>{{ item.name }}</span>
                  </div>
                  <router-link
                    :to="{
                      path: '/practice_test',
                      query: {
                        questions_id_str: item.questions_id_str,
                        paperName: item.name,
                        knowledge_basic_id: item.knowledge_basic_id,
                      },
                    }"
                    v-if="item.questions_num"
                    class="cl_gray block mat10"
                    >课后练习&nbsp;&nbsp;<span class="cl_yel"
                      >({{ item.questions_num }})</span
                    ></router-link
                  >
                </div>
              </div>
              <div
                class="video_bg flex bg_white"
                v-if="data.type == 2 && data.is_buy == 2"
              >
                <div class="cl_red f26px">¥ {{ data.price }}</div>
                <button class="cl_white f16px" @click="buyBtn">立即购买</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="study_like">
      <div class="w1200">
        <div class="hot_header tc">
          <h3 class="f26px bold">猜你喜欢</h3>
          <p class="f18px cl_tip mat5">GUESS WHAT YOU LIKE</p>
        </div>
        <div class="study_like_cont">
          <router-link
            :to="{ path: '/video', query: { id: item.id } }"
            v-for="(item, index) in likeList"
            :key="index"
            class="study_like_list"
          >
            <img :src="item.pic" class="block radius8" />
            <p class="clip f20px mat5">{{ item.name }}</p>
          </router-link>
        </div>
      </div>
    </div>
    <vfooter @child-event="publicEvent"></vfooter>

    <!-- 购买课程 -->
    <el-dialog title="购买课程" :visible.sync="buyShow" width="35%" center>
      <div class="buy_cont">
        <div class="buy_item">
          <div class="buy_item_l f16px cl_gray">课程名称</div>
          <div class="buy_item_r f20px">{{ data.name }}</div>
        </div>
        <div class="buy_item mat30">
          <div class="buy_item_l f16px cl_gray">课程价格</div>
          <div class="buy_item_r f26px cl_red">¥ {{ data.price }}</div>
        </div>
        <div class="buy_item mat30">
          <div class="buy_item_l f16px cl_gray">购买时间</div>
          <div class="buy_item_r f16px">{{ time }}</div>
        </div>
        <div class="buy_item mat30">
          <div class="buy_item_l f16px cl_gray">支付方式</div>
          <div class="buy_item_r">
            <div class="buy_type flex" style="flex-wrap: wrap">
              <div
                class="radius8 cur buy_type_item mab10"
                v-for="(item, index) in type"
                :key="index"
                :class="{ on: item.id == type_cur }"
                @click="type_cur = item.id"
              >
                <img :src="item.pic" />
                <span v-if="item.name != ''" class="mal5">{{ item.name }}</span>
                <img
                  src="../../../static/icon_checked.png"
                  class="buy_type_item_tip"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="buy_item mat30" v-if="type_cur == 1">
          <div class="buy_item_l f16px cl_gray">账户余额</div>
          <div class="buy_item_r f20px cl_red">{{ myInfo.balance }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer mab20">
        <button @click="buyConfirm" class="buy_submit f16px cl_white radius20">
          支付
        </button>
      </div>
    </el-dialog>
    <!-- 微信支付 -->
    <el-dialog
      title="微信支付"
      :visible.sync="wxShow"
      width="30%"
      :close-on-click-modal="false"
      :center="true"
      :destroy-on-close="true"
    >
      <div class="tc">
        <div class="qrcode inline" ref="qrCodeUrl"></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wxShow = false">取 消</el-button>
        <el-button type="primary" @click="wxConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import publicHeader from "../../components/header.vue";
import studyHeader from "../../components/study_header.vue";
import vfooter from "../../components/footer.vue";
import QRCode from "qrcodejs2";

export default {
  name: "study",
  components: {
    publicHeader,
    studyHeader,
    vfooter,
  },
  props: {},
  data() {
    return {

      studyNav: -1,
      subjectIndex: false, //学科分类显示
      myInfo: {},
      public: {},
      data: {},
      list_cur: {},
      //播放设置
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            type: "",
            //type: "video/mp4",
            src: "",
          },
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
      },
      likeList: [], //喜欢
      buyShow: false, //购买显示
      type: [
        {
          id: 1,
          pic: require("../../../static/icon_balance.png"),
          name: "余额支付",
        },
        {
          id: 2,
          pic: require("../../../static/payment_01.png"),
          name: "",
        },
        {
          id: 3,
          pic: require("../../../static/payment_02.png"),
          name: "",
        },
      ],
      type_cur: 1,
      seconds: 0,
      id: "",
      section: "",
      time: "",
      wxShow: false, //微信支付
      order_no: "", //订单号
      task_id: "", //作业视频
      done: "", //是否完成
      pack_id: "", //视频id
    };
  },
  mounted() {
    this.getHotvideo();
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
  },
  watch: {
    $route: {
      handler() {
        this.id = this.$route.query.id;
        this.getList();
      },
    },
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getList();
    }
    if (this.$route.query.task_id) {
      this.task_id = this.$route.query.task_id;
      this.done = this.$route.query.done;
      this.pack_id = this.$route.query.pack_id;
      this.getTaskNot();
    }
    if (this.$route.query.section) {
      this.section = this.$route.query.section;
    }
  },
  beforeDestroy() {},
  destroyed() {
    window.removeEventListener("beforeunload", (e) =>
      this.beforeunloadHandler(e)
    );
  },
  methods: {
    myInfoEvent(data) {
      this.myInfo = data;
    },
    publicEvent(data) {
      this.public = data;
    },
    beforeunloadHandler(e) {},
    //计时
    setTime() {
      this.seconds = 0;
      this.timer = setInterval(() => {
        this.seconds++;
      }, 1000);
    },
    getTaskNot() {
      this.$get("/api/student/get_my_homework_unfinished_dtl", {
        token: localStorage.getItem("token"),
        id: this.task_id,
      }).then((res) => {
        this.data = res.data.data;
        for (let i = 0; i < this.data.video.length; i++) {
          if (this.pack_id == this.data.video[i].pack_id) {
            this.list_cur = this.data.video[i];
          }
        }
	
        if (this.list_cur.url.includes(".mp4")) {
          this.playerOptions.sources[0].type = "video/mp4";
        } else {
          this.playerOptions.sources[0].type = "application/x-mpegURL";
        }
        this.playerOptions.sources[0].src = this.list_cur.url;

        this.playerOptions.poster = this.list_cur.pic;
      });
    },
    //热门视频
    getHotvideo() {
      this.$get("/api/course/course_index_hot_data", {
        pharse_id: localStorage.getItem("pharseId"),
        limit: 8,
      }).then((res) => {
        this.likeList = res.data;
      });
    },
    getList() {
      this.$get("/api/course/get_pack_sel", {
        token: localStorage.getItem("token"),
        id: this.id,
      }).then((res) => {
        this.data = res.data;
        if (this.section != "") {
          for (let i = 0; i < this.data.video.length; i++) {
            if (this.section == this.data.video[i].id) {
              this.list_cur = this.data.video[i];
            }
          }
        } else {
          this.list_cur = this.data.video[0];
        }
			console.log(this.list_cur.url,'url')
        if (this.list_cur.url.includes(".mp4")) {
		
          this.playerOptions.sources[0].type = "video/mp4";
        } else {
          this.playerOptions.sources[0].type = "application/x-mpegURL";
        }
        this.playerOptions.sources[0].src = this.list_cur.url;

        this.playerOptions.poster = this.list_cur.pic;

      });
    },
    // 播放回调
    onPlayerPlay(player) {
      if (this.data.type == 2 && this.data.is_buy == 2) {
        this.$refs.videoPlayer.player.pause();
        this.$message({
          type: "warning",
          message: "该课程为付费课程，请先购买或升级vip后观看",
          duration: 1500,
        });
        return false;
      }
      this.setTime();
    },
    //监听视频播放
    onPlayerTimeupdate(player) {
      this.gklog = player.cache_.currentTime;
      if (this.data.max_video_minute) {
        if (this.gklog > this.data.max_video_minute) {
          this.$refs.videoPlayer.player.pause();
          this.$message({
            type: "warning",
            message: "免费试看已结束，请购买或升级vip后观看",
            duration: 1500,
          });
        }
      }
    },
    // 暂停回调
    onPlayerPause(player) {
      clearInterval(this.timer);
      console.log(this.seconds);
    },
    // 视频播完回调
    onPlayerEnded(player) {
      clearInterval(this.timer);
      console.log(this.seconds);
    },
    //小节切换
    videoCheck(e) {
      this.list_cur = this.data.video[e];
      if (this.list_cur.url.includes(".mp4")) {
        this.playerOptions.sources[0].type = "video/mp4";
      } else {
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      }
      this.playerOptions.sources[0].src = this.list_cur.url;

      this.playerOptions.poster = this.list_cur.pic;
    },
    getTime() {
      let t = "";
      let myDate = new Date();
      let year = myDate.getFullYear();
      let month = myDate.getMonth() + 1;
      let date = myDate.getDate();
      let hours = myDate.getHours();
      let minutes = myDate.getMinutes();
      let seconds = myDate.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      t =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      return t;
    },
    buyBtn() {
      this.buyShow = true;
      this.time = this.getTime(new Date());
    },
    buyConfirm() {
      let return_url = window.location.href;
      if (this.type_cur == 2) {
        window.open(
          "http://res.joy366.com/api/course/user_pack_order?token=" +
            localStorage.getItem("token") +
            "&id=" +
            this.data.id +
            "&type=" +
            this.type_cur +
            "&return_url=" +
            return_url +
            "&platform=1",
          "_blank"
        );
      } else {
        this.$get("/api/course/user_pack_order", {
          token: localStorage.getItem("token"),
          type: this.type_cur,
          id: this.data.id,
          return_url: return_url,
          platform: 1, //1pc;2h5;3app
        }).then((res) => {
          if (this.type_cur == 1) {
            this.$message({
              duration: 1500,
              message: res.msg,
              type: "success",
            });
            setTimeout(() => {
              location.reload();
            }, 1500);
          } else if (this.type_cur == 3) {
            this.wxShow = true;
            this.order_no = res.data.order_no;
            setTimeout(() => {
              this.creatQrCode(res.data.code_url);
            }, 0);
          }
        });
      }
    },
    //生成二维码
    creatQrCode(url) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url,
        width: 250,
        height: 250,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    wxConfirm() {
      this.$get("/api/course/order_no_show", {
        token: localStorage.getItem("token"),
        order_no: this.order_no,
      }).then((res) => {
        if (res.data == 0) {
          this.$message({
            duration: 1500,
            message: "请先扫描支付",
            type: "warning",
          });
          return false;
        } else if (res.data == 1) {
          this.$message({
            duration: 1500,
            message: res.msg,
            type: "success",
          });
          setTimeout(() => {
            location.reload();
          }, 1500);
        }
      });
    },
  },
};
</script>

<style>
</style>
